const MAP_STYLES = [
  { elementType: "geometry", stylers: [{ color: "#f5f2ec" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#475569" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
  { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#cbd5e1" }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f4efe6" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#d7dee8" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#64748b" }] },
  { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#e7edf5" }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#cbd5e1" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9e5f3" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#64748b" }] }
]

let map = null
let markers = []
let infoWindows = []
let activeInfoWindow = null
let activeTile = null
let activeSelection = null
let mobileMapView = false

function escapeHtml(value) {
  const element = document.createElement("div")
  element.textContent = value == null ? "" : String(value)
  return element.innerHTML
}

function closeInfoWindow() {
  activeInfoWindow?.close()
  activeInfoWindow = null
  activeTile?.remove()
  activeTile = null
  activeSelection = null
}

function openHome(home, number, infoWindow, marker) {
  closeInfoWindow()
  activeSelection = { home, number, infoWindow, marker }
  mobileMapView = window.matchMedia("(max-width: 767px), (max-width: 1024px) and (max-height: 600px)").matches
  if (mobileMapView) {
    const tile = document.createElement("section")
    tile.className = "event-entry-map-tile"
    tile.setAttribute("role", "region")
    tile.setAttribute("aria-label", `Entry ${number}: ${home.title}`)
    tile.innerHTML = `<button type="button" class="event-entry-map-tile__close" aria-label="Close entry preview">&times;</button>${infoWindowContent(home, number)}`
    tile.querySelector(".event-entry-map-tile__close").addEventListener("click", closeInfoWindow)
    for (const eventName of ["click", "pointerdown", "touchstart", "wheel"]) {
      tile.addEventListener(eventName, (event) => event.stopPropagation())
    }
    document.getElementById("parade-homes-map").appendChild(tile)
    activeTile = tile
  } else {
    infoWindow.setContent(infoWindowContent(home, number))
    infoWindow.open(map, marker)
    activeInfoWindow = infoWindow
  }
}

function clearMap() {
  closeInfoWindow()
  markers.forEach((marker) => marker.setMap(null))
  infoWindows.forEach((infoWindow) => infoWindow.close())
  markers = []
  infoWindows = []
  map = null
}

function markerIcon(homeNumber) {
  return {
    url: "data:image/svg+xml," + encodeURIComponent(`
      <svg width="44" height="54" viewBox="0 0 44 54" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 53C22 53 42 34.1 42 21.5C42 10.18 33.05 1 22 1C10.95 1 2 10.18 2 21.5C2 34.1 22 53 22 53Z" fill="rgba(15,23,42,0.92)" stroke="rgba(255,255,255,0.72)" stroke-width="2"/>
        <circle cx="22" cy="21" r="14" fill="rgba(255,255,255,0.92)"/>
        <text x="22" y="26" text-anchor="middle" font-family="Arial, sans-serif" font-size="14" font-weight="700" fill="#0f172a">${escapeHtml(homeNumber)}</text>
      </svg>
    `),
    scaledSize: new google.maps.Size(44, 54),
    anchor: new google.maps.Point(22, 54)
  }
}

function homeNumber(home, index) {
  if (home.entryIdentifier) return home.entryIdentifier

  const match = home.label?.match(/#(\d+)/)
  return match ? match[1] : index + 1
}

function infoWindowContent(home, number) {
  const bedrooms = escapeHtml(home.stats?.bedrooms)
  const bathrooms = escapeHtml(home.stats?.bathrooms)
  const sqft = home.stats?.sqft ? Number.parseInt(home.stats.sqft, 10).toLocaleString() : ""

  return `
    <div class="event-entry-map-card bg-white text-slate-950" data-system-component="map-entry-popover">
      <div class="event-entry-map-card__media">
        ${home.imageUrl ? `<img src="${escapeHtml(home.imageUrl)}" alt="${escapeHtml(home.title)}" class="event-entry-map-card__photo h-32 w-full object-cover">` : ""}
        ${home.price ? `<span class="event-entry-map-card__price" aria-label="Price: ${escapeHtml(home.price)}">${escapeHtml(home.price)}</span>` : ""}
      </div>
      <div class="event-entry-map-card__body p-4">
        <div class="event-entry-map-card__meta">
          <p class="text-xs font-semibold uppercase tracking-widest text-slate-500">Entry ${escapeHtml(number)}</p>
          ${home.city ? `<span class="event-entry-map-card__city"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>${escapeHtml(home.city)}</span>` : ""}
        </div>
        <h3 class="mt-1 text-base font-bold leading-snug">${escapeHtml(home.title)}</h3>
        ${home.builder ? `<p class="mt-2 text-sm font-semibold text-slate-800">${escapeHtml(home.builder)}</p>` : ""}
        <p class="mt-2 text-sm leading-snug text-slate-600">${escapeHtml(home.address)}</p>
        ${(bedrooms || bathrooms || sqft) ? `
          <div class="mt-3 flex flex-wrap gap-2 text-xs text-slate-600">
            ${bedrooms ? `<span class="rounded-full border border-slate-900/12 bg-slate-50 px-2 py-1">${bedrooms} bed</span>` : ""}
            ${bathrooms ? `<span class="rounded-full border border-slate-900/12 bg-slate-50 px-2 py-1">${bathrooms} bath</span>` : ""}
            ${sqft ? `<span class="rounded-full border border-slate-900/12 bg-slate-50 px-2 py-1">${sqft} sq ft</span>` : ""}
          </div>
        ` : ""}
        <div class="mt-4 flex flex-col gap-2">
          <a href="${escapeHtml(home.url)}" data-turbo-frame="_top" class="inline-flex w-full items-center justify-center rounded-full bg-slate-900 px-3 py-2 text-sm font-semibold text-white">View Entry</a>
          <div class="grid grid-cols-[1fr_auto] gap-2">
            <div data-controller="tour-project"
                 data-tour-project-id-value="${escapeHtml(home.id)}"
                 data-tour-project-added-value="${Boolean(home.inTour)}"
                 data-tour-project-guest-value="${Boolean(home.guest)}"
                 data-tour-project-storage-key-value="${escapeHtml(home.tourStorageKey)}">
              <button type="button"
                      data-action="click->tour-project#toggle"
                      data-tour-project-solid="true"
                      class="inline-flex h-10 w-full items-center justify-center rounded-full ${home.inTour ? "bg-primary-600" : "bg-slate-900"} px-3 text-sm font-semibold text-white"
                      aria-label="${home.inTour ? "Added to My Tour" : "Add to My Tour"}"
                      title="${home.inTour ? "Added to My Tour" : "Add to My Tour"}">
                <span data-tour-project-label>${home.inTour ? "Added to My Tour" : "Add to My Tour"}</span>
              </button>
            </div>
            <div data-controller="favorites"
                 data-favorites-type-value="project"
                 data-favorites-id-value="${escapeHtml(home.id)}"
                 data-favorites-favorited-value="${Boolean(home.favorited)}">
              <button type="button"
                      data-action="click->favorites#toggle"
                      data-favorites-saved-title="Remove from favorites"
                      data-favorites-unsaved-title="Add to favorites"
                      class="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-900 text-slate-900 transition hover:bg-slate-100"
                      aria-label="${home.favorited ? "Remove from favorites" : "Add to favorites"}"
                      title="${home.favorited ? "Remove from favorites" : "Add to favorites"}">
                <svg class="pointer-events-none h-5 w-5 ${home.favorited ? "text-primary-600" : "text-gray-700"}"
                     viewBox="0 0 24 24"
                     ${home.favorited ? 'fill="currentColor"' : 'fill="none" stroke="currentColor" stroke-width="2"'}>
                  ${home.favorited
                    ? '<path d="M12 21s-9-4.78-9-12c0-2.485 2.1-4.5 4.688-4.5 1.935 0 3.597 1.126 4.312 2.733C12.715 5.626 14.377 4.5 16.313 4.5 18.9 4.5 21 6.515 21 9c0 7.22-9 12-9 12z"/>'
                    : '<path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/>'}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}

function initFilteredParadeHomesMap() {
  if (!window.google?.maps) return

  const mapElement = document.getElementById("parade-homes-map")
  if (!mapElement) return

  const homes = JSON.parse(mapElement.dataset.paradeHomes || "[]")
  if (homes.length === 0) return

  clearMap()

  const center = {
    lat: homes.reduce((sum, home) => sum + home.lat, 0) / homes.length,
    lng: homes.reduce((sum, home) => sum + home.lng, 0) / homes.length
  }

  map = new google.maps.Map(mapElement, {
    center,
    zoom: 12,
    styles: MAP_STYLES,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: true
  })
  map.addListener("click", closeInfoWindow)

  homes.forEach((home, index) => {
    const number = homeNumber(home, index)
    const marker = new google.maps.Marker({
      position: { lat: home.lat, lng: home.lng },
      map,
      title: home.title,
      icon: markerIcon(number)
    })
    const infoWindow = new google.maps.InfoWindow({ maxWidth: 320 })

    marker.addListener("click", () => {
      openHome(home, number, infoWindow, marker)
    })

    markers.push(marker)
    infoWindows.push(infoWindow)
  })

  if (markers.length > 1) {
    const bounds = new google.maps.LatLngBounds()
    markers.forEach((marker) => bounds.extend(marker.getPosition()))
    map.fitBounds(bounds)
    google.maps.event.addListenerOnce(map, "bounds_changed", () => {
      if (map.getZoom() > 15) map.setZoom(15)
    })
  }

  window.paradeHomesMap = map
  window.paradeHomesMarkers = markers
}

window.initFilteredParadeHomesMap = initFilteredParadeHomesMap
window.addEventListener("resize", () => {
  if (map) google.maps.event.trigger(map, "resize")
  if (activeSelection && mobileMapView !== window.matchMedia("(max-width: 767px), (max-width: 1024px) and (max-height: 600px)").matches) {
    const { home, number, infoWindow, marker } = activeSelection
    openHome(home, number, infoWindow, marker)
  }
})
window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeInfoWindow()
})
document.addEventListener("turbo:before-cache", clearMap)
